import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  Injector,
  ReflectiveInjector,
  ComponentFactoryResolver,
  ViewContainerRef,
  OnInit
} from "@angular/core";

import {
  trigger,
  state,
  style,
  animate,
  transition,
  AnimationEvent
} from "@angular/animations";

import * as _ from "lodash";

import { Dialog, DialogRef, DialogParams } from "../../dialog.base";

/**
 * @ignore
 */
@Component({
  selector: "uex-dialog",
  templateUrl: "./dialog.component.html",
  host: {
    class: "uex-dialog"
  },
  animations: [
    trigger("dialog", [
      state(
        "initial",
        style({
          transform: "translateY(-25%)",
          opacity: 0,
          visibility: "hidden"
        })
      ),
      state(
        "hidden",
        style({
          transform: "translateY(-25%)",
          opacity: 0,
          visibility: "hidden"
        })
      ),
      state(
        "shown",
        style({ transform: "translateY(0)", opacity: 1, visibility: "visible" })
      ),
      transition("hidden => shown", animate(DialogComponent.ANIMATION_TIME)),
      transition("shown => hidden", animate(DialogComponent.ANIMATION_TIME))
    ]),
    trigger("backdrop", [
      state("initial", style({ opacity: 0, visibility: "hidden" })),
      state("hidden", style({ opacity: 0, visibility: "hidden" })),
      state("shown", style({ opacity: 1, visibility: "visible" })),
      transition("hidden => shown", animate(DialogComponent.ANIMATION_TIME)),
      transition("shown => hidden", animate(DialogComponent.ANIMATION_TIME))
    ])
  ]
})
export class DialogComponent implements OnInit {
  @ViewChild("content", { read: ViewContainerRef, static: true })
  content: ViewContainerRef;
  @ViewChild("dialogContent", { static: true }) dialogContent: ElementRef;
  @ViewChild("dialogWrapper", { static: true }) dialogWrapper: ElementRef;
  @Input("dialog") dialog: Dialog;

  public static ANIMATION_TIME: number = 100;

  constructor(
    private _compiler: ComponentFactoryResolver,
    public elementRef: ElementRef
  ) {}

  public ready: boolean = false;
  public get shown(): boolean {
    return this._shown;
  }
  public get visible(): boolean {
    return this._visible;
  }
  public set visible(visible: boolean) {
    if (visible) {
      this._visible = true;

      setTimeout(() => {
        this._shown = true;
      }, 0);
    } else {
      this._shown = false;

      setTimeout(() => {
        this._visible = false;
      }, DialogComponent.ANIMATION_TIME + 50);
    }
  }

  private _visible: boolean = false;
  private _shown: boolean = false;

  public ngOnInit() {
    const dialogRef: DialogRef = new DialogRef();
    const dialogParams = this.dialog.params;
    dialogRef.dialog = this.dialog;
    const injector: Injector = ReflectiveInjector.resolveAndCreate([
      { provide: DialogRef, useValue: dialogRef },
      { provide: DialogRef, useValue: dialogRef },
      { provide: DialogParams, useValue: dialogParams },
      { provide: DialogParams, useValue: dialogParams }
    ]);
    const compiled_component = this._compiler.resolveComponentFactory(
      this.dialog.component
    );
    this.dialog.componentRef = this.content.createComponent(
      compiled_component,
      null,
      injector
    );
    this.dialog.componentInstance = this;
    this.ready = true;
    this.dialog.$onReady.emit();
  }

  public animationStart(event: AnimationEvent) {
    if (event.fromState == "shown" && event.toState == "hidden") {
      this.dialog.onHide.emit();
    }
  }

  public animationEnd(event: AnimationEvent) {
    if (event.fromState == "hidden" && event.toState == "shown") {
      this.dialog.onShown.emit();
    }

    if (event.fromState == "shown" && event.toState == "hidden") {
      this.dialog.onHidden.emit();
    }
  }

  public get state(): string {
    return this.ready ? (this.shown ? "shown" : "hidden") : "initial";
  }

  public get zindex(): any {
    return this.dialog.zindex;
  }

  public get content_zindex(): number {
    return this.dialog.content_zindex;
  }

  public get backdrop_zindex(): any {
    return this.dialog.backdrop_zindex;
  }

  public get fit_to_screen(): boolean {
    return this.dialog.fit_to_screen;
  }

  public get wrapper_class(): string {
    return this.dialog.wrapper_class;
  }

  public get dialog_class(): string {
    return `${this.dialog.sizeClass()}${
      this.dialog.dialog_class ? ` ${this.dialog.dialog_class}` : ""
    }`;
  }

  public get content_class(): string {
    return this.dialog.content_class;
  }

  public get backdrop_class(): string {
    return this.dialog.backdrop_class;
  }

  public backdropClick(event: MouseEvent) {
    const target: any = event.target;
    if (target && !target.classList.contains("uex-dialog-modal")) return;
    switch (this.dialog.settings.backdrop.onClick) {
      case "close":
        this.dialog.close();
        break;
      case "dismiss":
        this.dialog.dismiss();
        break;
      case "none":
        break;
      default:
        this.dialog.close();
    }
  }

  public headerCloseClick() {
    if (!this.dialog.settings.header.closable) return;
    switch (this.dialog.settings.header.closeClick) {
      case "close":
        this.dialog.close();
        break;
      case "dismiss":
        this.dialog.dismiss();
        break;
      default:
        this.dialog.close();
    }
  }
}
